import React from 'react';
import './aboutUs.css';
import PageBanner from '../../components/page-banners/pageBanner';
import AboutUsImage from '../about-us/assets/brocon-building-final.jpg'
import Portfolio from '../../components/project-portfolio/portfolio';

function AboutUs() {
  return (
    <>
      <PageBanner
        title="About Us"
        subtitle=""
        bannerImage={AboutUsImage}
        altText="Brocon Contruction main building in Grove City Ohio "
      />
      <div className="mainContent">
        <div className='textBlock' id='about-us'>
          <h2>Quailty Is Our Business</h2>
          <p> Founded in 1988, Brocon Construction, Inc. has built a strong reputation
            as a trusted leader in the Columbus construction industry. We began as
            a subcontractor specializing in metal stud framing, drywall, and
            acoustic ceilings, known for our commitment to quality and reliability.
            <br></br>
            <br></br>
            Over the years, that dedication fueled our evolution into a full-service
            general contractor and owner’s representative. By 2003, Brocon had
            expanded its reach by providing project management and general
            supervision across a wide range of commercial and industrial projects.
            <br></br>
            <br></br>
            Today, our success is driven by repeat business and long-term
            partnerships a reflection of the trust we’ve earned through
            consistent performance and results.
            <br></br>
            <br></br>
            At Brocon, we take pride in our turnkey approach. From the initial
            budgeting phase through final occupancy, a single representative
            oversees every detail, ensuring clarity, accountability, and a seamless
            construction experience.
            <br></br>
            Our mission remains simple: deliver exceptional quality, build lasting
            relationships, and stand behind every project we complete
          </p>
        </div>

        <div className='aboutUsPortfolio'>
          <h2>Featured Work</h2>
          <Portfolio />
        </div>

        <div className='sideBySide'>
          <div className='textBlock'>
            <h3>Leadership</h3>
            <p>The Brocon Construction leadership team has over 170+ years combined experience in the industry. Our team of professionals is proud of the work we do and is always ensuring we deliver quality products and services.</p>
          </div>
          <div className='textBlock'>
            <h3>Managment Process</h3>
            <p>Our project management skills are among the best in the industry. We ensure smooth project flow and timely, quality work by maintaining a standardized approach to every job.</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default AboutUs;